module.exports = __webpack_public_path__ + "img/type-of-platform-wikitude.fc56f327.webp";